import React from 'react';
import SearchBarComponent from 'material-ui-search-bar';

interface Props {
    placeholder?: string,
    value: string,
    setValue: (s: string) => void
}

export default function SearchBar(props: Props) {
    

    return (
        <SearchBarComponent
            style={{ backgroundColor: '#fff' }}
            classes={{ input: "lightInput" }}
            placeholder={props?.placeholder}
            value={props.value}
            onChange={props.setValue}
            // onRequestSearch={() => console.log(value)}
        />
    )
}
